import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { AiOutlineLock } from "react-icons/ai";

const Overlay = () => {
  return (
    <div className='flex-grow min-h-full bg-gray-200/90'>
      <div className="grid place-content-center h-full">
        <AiOutlineLock className="  text-gray-500 text-[160px]  " />
        <button
        type="button"
        className="flex gap-2 items-center border-2 bg-indigo-500 text-white p-2 px-12 rounded-lg hover:cursor-pointer"
      >
        {" "}
        <a
          href="https://causalfunnel.com/contact?utm_source=CausalFunnel_Dashboard"
          target="_blank"
          rel="noreferrer noopener"
        >
          {" "}
          Unlock This Tab
        </a>
        <CheckCircleIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />
      </button>
        </div>
    </div>
  )
}

export default Overlay